import { ControlValueAccessor } from '@angular/forms'

const noop = (): void => {} // eslint-disable-line

/**
 * Factory for providers to mark the component as a ng_value_accessor
 * use like this :
 * ```ts
 * @Component({
 *  providers:[CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR(() => ComponnentClass)]
 * })
 * ```
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = function <T>(comp: Type<T>) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: comp,
    multi: true
  };
}

 */

export class CustomNgModel implements ControlValueAccessor {
  protected _inputValue: unknown = ''

  /**  Placeholders for the callbacks which are later providesd
   * by the Control Value Accessor **/
  protected _onTouchedCallback: () => void = noop

  protected _onChangeCallback: (_: unknown) => void = noop

  /**  Get accessor */
  public get value(): unknown {
    return this._inputValue
  }

  /** Set accessor including call the onchange callback */
  public set value(v: unknown) {
    if (v !== this._inputValue) {
      this._inputValue = v
      this._onChangeCallback(v)
    }
  }

  /**  Set touched on blur **/
  public onBlur(): void {
    this._onTouchedCallback()
  }

  /** Form ControlValueAccessor interface */
  public writeValue(value: unknown): void {
    if (value !== this._inputValue) {
      this._inputValue = value
    }
  }

  /** Form ControlValueAccessor interface */
  public registerOnChange(fn: any): void {
    this._onChangeCallback = fn
  }

  /** Form ControlValueAccessor interface */
  public registerOnTouched(fn: any): void {
    this._onTouchedCallback = fn
  }
}
